import React from 'react';
import CoachingPreferencesNote from './sections/CoachingPreferencesNote';

/**
 * The public coaching-style tab.
 *
 * The preference line matters most here. On his own profile a coach knows he
 * typed these words; a club looking at the public page does not, and a row of
 * tactical terms under a name reads like something the platform established and
 * is handing over. It is not. The line says so before the first chip.
 */
const StyleChips = ({ title, entries, emptyLabel }) => (
  <div>
    <h2 className="text-[#222A35] text-base font-bold mb-4">{title}</h2>
    <div className="flex flex-wrap gap-3">
      {entries?.length > 0 ? (
        entries.map((entry, index) => (
          <div
            key={index}
            className="px-4 py-2 rounded-full"
            style={{
              background: 'linear-gradient(90deg, rgba(126, 139, 255, 0.2) 0%, rgba(34, 131, 255, 0.2) 100%)'
            }}
          >
            <span className="text-[#374DF5] text-base">
              {entry}
            </span>
          </div>
        ))
      ) : (
        <div className="w-full bg-[#F8F9FB] py-4 rounded-lg text-center">
          <p className="text-[#646B7E] text-sm">{emptyLabel}</p>
        </div>
      )}
    </div>
  </div>
);

const CoachCoachingStyle = ({ coach }) => {
  return (
    <div className="space-y-8">
      <CoachingPreferencesNote />

      <StyleChips
        title="Playing Style"
        entries={coach.playingStyle}
        emptyLabel="No playing style information available"
      />

      <StyleChips
        title="Defensive Tactics"
        entries={coach.defensiveTactics}
        emptyLabel="No defensive tactics information available"
      />

      {/* The half that never had a place to be shown. */}
      <StyleChips
        title="Offensive Tactics"
        entries={coach.offensiveTactics}
        emptyLabel="No offensive tactics information available"
      />

      {/* Additional Notes Section */}
      <div>
        <h2 className="text-[#222A35] text-base font-bold mb-4">Additional Notes</h2>
        <div className="w-full bg-[#F8F9FB] py-4 px-6 rounded-lg">
          <p className="text-[#43526E] text-sm">
            {coach.additionalNotes && coach.additionalNotes !== "N/A" ? coach.additionalNotes : "No additional notes available"}
          </p>
        </div>
      </div>
    </div>
  );
};

export default CoachCoachingStyle;
